import { type PremiumFeaturesReturnProps } from '@/services/types/premiumFeatures/premiumFeatures'
import { api, v2BaseURL } from './api'
import { endpoints } from './endpoints'

export const premiumFeaturesService = {
  async getPremiumFeatures() {
    return api.get<PremiumFeaturesReturnProps>(endpoints.premiumFeatures, {
      baseURL: v2BaseURL,
    })
  },
}
